import { Instagram, Youtube, Facebook, Phone, Mail, MapPin, MessageCircle } from "lucide-react";
import { Logo, PlayButton } from "@/components/Bits";
import { SOCIAL, CONTACT, APP_LINKS, SERVICES, CITIES } from "@/data/site";

const socials = [
  { icon: Instagram, href: SOCIAL.instagram, label: "Instagram" },
  { icon: Youtube, href: SOCIAL.youtube, label: "YouTube" },
  { icon: Facebook, href: SOCIAL.facebook, label: "Facebook" },
];

export default function Footer() {
  return (
    <footer className="relative bg-azo-surface border-t border-azo-border pt-16 pb-8" data-testid="footer-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="grid grid-cols-2 gap-8 sm:gap-10 lg:grid-cols-[1.4fr_1fr_1fr_1.3fr]">
          {/* brand */}
          <div className="col-span-2 lg:col-span-1">
            <Logo className="h-16 sm:h-20" testid="footer-brand-logo" />
            <p className="mt-5 max-w-xs text-sm text-azo-muted leading-relaxed">
              AzoApp — Bihar ka apna on-demand home service app. Trusted professionals, seedhe aapke doorstep par.
            </p>
            <div className="mt-5 flex items-center gap-3">
              {socials.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  className="grid h-10 w-10 place-items-center rounded-full border border-azo-border text-azo-muted hover:bg-azo-primary hover:text-white hover:border-azo-primary transition-all duration-300"
                >
                  <s.icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* services */}
          <div>
            <p className="font-heading font-semibold text-sm uppercase tracking-widest text-azo-muted mb-4">Services</p>
            <ul className="space-y-2.5">
              {SERVICES.map((s) => (
                <li key={s.id}>
                  <a href="#services" className="text-sm text-azo-text/90 hover:text-azo-primary transition-colors">{s.name}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* cities */}
          <div>
            <p className="font-heading font-semibold text-sm uppercase tracking-widest text-azo-muted mb-4">Cities</p>
            <ul className="space-y-2.5">
              {CITIES.map((c) => (
                <li key={c.name}>
                  <a href="#cities" className="text-sm text-azo-text/90 hover:text-azo-primary transition-colors">{c.name}</a>
                </li>
              ))}
            </ul>
          </div>

          {/* contact + apps */}
          <div className="col-span-2 lg:col-span-1">
            <p className="font-heading font-semibold text-sm uppercase tracking-widest text-azo-muted mb-4">Get in touch</p>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={`tel:${CONTACT.phone}`} className="flex items-center gap-2.5 text-azo-text/90 hover:text-azo-primary transition-colors">
                  <Phone size={15} className="text-azo-primary" /> {CONTACT.phoneDisplay}
                </a>
              </li>
              <li>
                <a href={`https://wa.me/${CONTACT.whatsapp}`} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 text-azo-text/90 hover:text-azo-primary transition-colors">
                  <MessageCircle size={15} className="text-azo-primary" /> WhatsApp chat
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2.5 text-azo-text/90 hover:text-azo-primary transition-colors">
                  <Mail size={15} className="text-azo-primary" /> {CONTACT.email}
                </a>
              </li>
              <li className="flex items-start gap-2.5 text-azo-muted">
                <MapPin size={15} className="text-azo-primary mt-0.5 shrink-0" /> {CONTACT.address}
              </li>
            </ul>
            <div className="mt-5 flex flex-col gap-2.5">
              <PlayButton href={APP_LINKS.customer} label="BOOK A SERVICE" store="Customer App" variant="ghost" testid="footer-btn-customer-app" />
              <PlayButton href={APP_LINKS.partner} label="EARN AS PARTNER" store="Partner App" variant="ghost" testid="footer-btn-partner-app" />
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-azo-border flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-azo-muted">© {new Date().getFullYear()} AzoApp. Service at Your Doorstep. All rights reserved.</p>
          <div className="flex items-center gap-5 text-xs text-azo-muted">
            <a href="#services" className="hover:text-azo-primary transition-colors">Privacy Policy</a>
            <a href="#services" className="hover:text-azo-primary transition-colors">Terms</a>
            <span className="font-mono2">Made in Bihar 🇮🇳</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
